import Vue from 'vue'
import App from './App.vue'
import './registerServiceWorker'
import router from './router/routers.js'
import store from './store'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import 'animate.css';
import Vant from 'vant';
import { Locale } from 'vant';

import enES from 'vant/es/locale/lang/es-ES';

import 'vant/lib/index.css';

Locale.use('es-ES', enES);
Vue.use(ElementUI);
Vue.use(Vant);

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
